
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WaitForJudgeToReview extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;
    
}
